module.exports = __webpack_public_path__ + "img/Arrow - Right.2d1673da.svg";